import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { PersonTypeIcon } from "components/icons/PersonTypeIcon";
import { EntityTypeIcon } from "components/icons/EntityTypeIcon";
import { ReactNode } from "react";

const SelectTypeCard = ({
  icon,
  title,
  description,
  onClick,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}) => (
  <Button
    type="button"
    customType="secondary"
    onClick={onClick}
    className="!t-h-auto !t-w-full !t-justify-start !t-rounded-xl !t-border-neutral-10 !t-bg-surface !t-p-3 !t-shadow-none hover:!t-border-purple hover:!t-bg-surface"
  >
    <span className="t-flex t-w-full t-items-start t-gap-3 t-text-left">
      <span className="t-flex t-h-9 t-w-9 t-flex-shrink-0 t-items-center t-justify-center t-rounded t-bg-surface-grey t-text-neutral-40">
        {icon}
      </span>
      <span className="t-flex t-flex-col t-gap-0.5">
        <span className="t-text-subtext t-text-text-60">{title}</span>
        <span className="t-text-body-sm t-text-neutral-50">{description}</span>
      </span>
    </span>
  </Button>
);

export const SelectPersonOrEntityType = ({
  onClose,
  onSelectPerson,
  onSelectEntity,
}: {
  onClose: () => void;
  onSelectPerson: () => void;
  onSelectEntity: () => void;
}) => (
  <>
    <Modal.Header>
      <Modal.Title>Select who you are adding</Modal.Title>
      <Modal.Close onClick={onClose} />
    </Modal.Header>
    <Modal.Body>
      <div className="t-mb-3 t-text-body-sm t-text-text-30">
        Choose the type of owner or company representative you'd like to add.
      </div>
      <div className="t-flex t-flex-col t-gap-3">
        <SelectTypeCard
          icon={<PersonTypeIcon />}
          title="A person"
          description="Add a director, officer, or individual shareholder."
          onClick={onSelectPerson}
        />
        <SelectTypeCard
          icon={<EntityTypeIcon />}
          title="An entity"
          description="Add a company, fund, trust, or other organization as a shareholder."
          onClick={onSelectEntity}
        />
      </div>
    </Modal.Body>
  </>
);
